module.exports = __webpack_public_path__ + "media/vo-02-modal.7361a1c0.mp3";